import axios from './BaseService';

const USERS_URL = `${process.env.REACT_APP_API_URL}/users/`;

export async function getActiveUsers(token) {
    const headers = { 'authorization': token };
    const response = await axios.get(`${USERS_URL}active`, { headers });
    return response.data;
}

export async function getUsers(search, page, token) {
    const usersUrl = `${USERS_URL}${search ? search : ''}?page=${page}`;

    const headers = { 'authorization': token };
    const response = await axios.get(usersUrl, { headers });
    return response.data;//{count, rows}
}

export async function saveUser(id, newUser, token) {
    const headers = { 'authorization': token };
    let response;
    if (id)
        response = await axios.patch(`${USERS_URL}${id}`, newUser, { headers });
    else
        response = await axios.post(USERS_URL, newUser, { headers });
    return response.data;
}

export async function deleteUser(id, token) {
    const headers = { 'authorization': token };
    const response = await axios.delete(`${USERS_URL}${id}`, { headers });
    return response.data;
}

export async function getIndicacoes(id, token) {
    const indicacoesUrl = `${USERS_URL}indi/id/${id}`;
    const headers = { 'authorization': token }
    console.log('local das pessoas que me indicaram--->');
    console.log(indicacoesUrl);
    const response = await axios.get(indicacoesUrl, { headers });
    return response.data;
}